<header class="head">
  <div class="lead">
    @if (title(); as shown) {
      <!-- SBUX-1179: no item avatar before the title (Wook, 2026-10-28). -->
      @if (editing()) {
        <!-- §11.6.1, AM-48: the title, renamed in place. Enter or leaving the field saves; Escape cancels. -->
        <input
          #titleInput
          class="title-input"
          type="text"
          [attr.aria-label]="S['Workbook title']"
          [value]="draft()"
          [attr.maxlength]="TITLE_MAX"
          (input)="typed($event)"
          (keydown.enter)="commitRename()"
          (keydown.escape)="cancelRename()"
          (blur)="commitRename()"
        />
      } @else {
        <h1 class="title">
          <button type="button" class="title-button" [attr.aria-label]="shown" [disabled]="!renamable()" (click)="startRename()">{{ shown }}</button>
        </h1>
      }
    }
    <!-- AM-78: the save state moved here from a row of its own. -->
    @if (saveStatus.current(); as status) {
      <!-- §5.4: "Saved" with check icon; the prototype's green check before the text (editor review row 6). -->
      <span class="state" [attr.data-state]="status.state" role="status">
        @if (status.state === 'clean') {
          <app-icon class="state__check" name="check" size="14" weight="2" />
        }
        {{ status.label }}
      </span>
    }
  </div>
  <!-- The prototype's editor title bar, after the save state: Archive and Trash (the item form's own, projected by it,
       SBUX-1036), Download and share, Item actions, then Close. -->
  <div class="actions">
    <ng-content select="[headerLifecycle]" />
    @if (saveStatus.current()) {
      <span class="menuhost" (keydown)="downloadKey($event, downloadButton)">
        <button
          #downloadButton
          type="button"
          class="hbtn"
          [class.hbtn--active]="downloadOpen()"
          [title]="S['Download and share']"
          [attr.aria-label]="S['Download and share']"
          aria-haspopup="menu"
          [attr.aria-expanded]="downloadOpen()"
          (click)="toggleDownload(downloadButton)"
        >
          <!-- SBUX-1179: Slides' Share icon, as the detail view's Share and Slides' editor header have it. -->
          <mat-icon class="hbtn__icon" svgIcon="sapphire-share" />
        </button>
        @if (downloadOpen()) {
          <app-download-menu [style.--dl-top.px]="downloadAt().top" [style.--dl-right.px]="downloadAt().right" (action)="pickDownload($event)" />
        }
      </span>
    }
    @if (menuItem(); as sheet) {
      <!-- The workbook's own item menu, as the detail view's "…" opens it, without what the editor has no use
           for (Open; Duplicate, AM-69). -->
      <button
        #itemMenuButton
        type="button"
        class="hbtn"
        [title]="S['Item actions']"
        [attr.aria-label]="S['Item actions']"
        [appSheetContextMenu]="sheet"
        appSheetContextMenuMode="popover"
        [appSheetContextMenuInEditor]="true"
        (appSheetContextMenuOpened)="itemMenuOpen.set($event)"
      >
        <app-icon name="dots" size="17" />
      </button>
    }
    <!-- The prototype's "Close editor", an X (SBUX-1036). -->
    <button type="button" class="hbtn hbtn--close" [title]="S['Close workbook']" [attr.aria-label]="S['Close workbook']" (click)="closed.emit()">
      <app-icon name="close" size="16" />
    </button>
  </div>
</header>
